<script>
import {mapActions, mapMutations, mapGetters} from 'vuex';
import edit from './codeEdit';
import config from '@/modules/config/columns';
export default {
	created() {
	},
	props: {
		handlerCodeSearch: {
			type: Function,
			required: true
		},
		searchQuery: {
			type: Object,
			required: true
		},
		selectOption: {
			type: Object,
			required: true
		}
	},
	data() {
        return {
        }
    },
	methods: {
		addCodeModel() {
			this.$refs.edit.modelStatus(true);
		},
		reset() {
			this.$clearObject(this.searchQuery);
			this.selectOption.cityId = [];
		},
		change(value, type) {
			this.$emit('change', {value, type});
		},
		...mapActions('zft', ['authModify'])
	},
	computed: {
		config() {
			return config;
		}
	},
	components: {
		edit
	}
}
</script>
<template>
<div class="name-search">
	<el-row :gutter="20">
	    <el-col :span="6">
	        <el-input v-model="searchQuery.mobile" @change="change($event, 'mobile')" placeholder="手机号码"></el-input>
	    </el-col>
	    <el-col :span="6">
			<el-select v-model="searchQuery.provinceId" class="common-width"
			   placeholder="省份选择"
			   @change="change($event, 'provinceId')"
			>
				<el-option
					v-for="item in selectOption.provinceId"
					:key="item.districtId"
					:label="item.districtName"
					:value="item.districtId"
				>
				</el-option>
			</el-select>
	    </el-col>
		<el-col :span="6">
			<el-select v-model="searchQuery.cityId" class="common-width"
			   placeholder="城市选择"
			   @change="change($event, 'cityId')"
			>
				<el-option
					v-for="item in selectOption.cityId"
					:key="item.districtId"
					:label="item.districtName"
					:value="item.districtId"
				>
				</el-option>
			</el-select>
	    </el-col>
        <el-col :span="6">
			<el-date-picker
			    class="common-width"
				v-model="searchQuery.queryTimeBegin"
				type="date"
				placeholder="选择开始日期"
				value-format="yyyy-MM-dd"
				@change="change"
			>
			</el-date-picker>
	    </el-col>
	</el-row><br/>
    <el-row :gutter="20">
         <el-col :span="6">
			<el-date-picker
			    class="common-width"
				v-model="searchQuery.queryTimeEnd"
				type="date"
				placeholder="选择结束日期"
				value-format="yyyy-MM-dd"
				@change="change"
			>
			</el-date-picker>
	    </el-col>
        <el-col :span="6">
	        <el-button type="primary" @click="handlerCodeSearch">搜索</el-button>
	        <el-button type="primary" @click="reset">重置</el-button>
    	    <!-- <el-button type="primary" @click="addCodeModel">导出</el-button> -->
	    </el-col>
    </el-row>
</div>
</template>
<style scoped lang="stylus">
.el-header
    line-height 60px
    padding 0 10px
.avatar-uploader
    display inline-block
    margin-left 80%
</style>
